export default {"src":"/_next/static/media/premium.fd3ad642.svg","height":11,"width":12,"blurWidth":0,"blurHeight":0};